import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import API from 'api';
import { QUERY_KEYS } from 'api/certificates/queries';
import Button from 'components/Buttons';
import FavouriteStarDefault from 'components/Icons/FavouriteStar';
import SpinnerDefault from 'components/Icons/Spinner';

type ToggleFavouriteProps = {
  jobId: string;
  isFavourite: boolean;
  children?: React.ReactNode;
  hasDarkOutline?: boolean;
  isClickable?: boolean;
};

const ToggleFavouriteButton = ({
  isClickable,
  jobId,
  isFavourite,
  children,
  hasDarkOutline,
}: ToggleFavouriteProps) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { mutate: toggleIsFavourite, isLoading } = useMutation(
    () => API.documents.patchDocumentIDFavourite(jobId, !isFavourite),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEYS.GET_CERTIFICATES);
        isFavourite
          ? message.success(t('success.removeFromFavourites'))
          : message.success(t('success.addToFavourites'));
      },
      onError: () => {
        isFavourite
          ? message.error(t('error.removeFromFavourites'))
          : message.error(t('error.addToFavourites'));
      },
    }
  );
  const handleAreaClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    !isLoading && toggleIsFavourite();
  };

  const buttonIcon = isLoading ? (
    <SpinnerDefault />
  ) : (
    <FavouriteStarDefault $hasDarkOutline={hasDarkOutline} $isFavourite={isFavourite} />
  );
  return (
    <Button
      type={'text'}
      style={{
        height: '100%',
        fontSize: '12px',
        marginLeft: '-10px',
        alignSelf: 'center',
      }}
      $customIcon
      $reverse
      icon={buttonIcon}
      onClick={handleAreaClick}
      disabled={!isClickable}
    >
      {children}
    </Button>
  );
};

export default ToggleFavouriteButton;
